import { useRef } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import { Link } from 'react-router-dom';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      'service_on93dvd',
      'template_22etrz9',
      form.current,
      'LFV7eQdiRwdG4jPTE'
    ).then(
      () => alert('Message Sent Successfully!'),
      () => alert('Message Failed to Send. Please Try Again.')
    );
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-label">Get In Touch</span>
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle">
            Have a shipment in mind? Reach out and we'll get back to you promptly.
          </p>
        </div>

        <div className="row g-4">
          {/* Contact Form */}
          <div className="col-lg-6" data-aos="fade-right">
            <div className="contact__card">
              <h5 className="contact__card-title">Send Us a Message</h5>
              <p className="contact__card-sub">Fill out the form and we'll respond within one business day.</p>
              <form ref={form} onSubmit={sendEmail}>
                <div className="mb-3">
                  <label className="chi-label">Your Name *</label>
                  <input type="text" className="chi-input" name="from_name" placeholder="Full name" required />
                </div>
                <div className="mb-3">
                  <label className="chi-label">Email Address *</label>
                  <input type="email" className="chi-input" name="from_email" placeholder="your@email.com" required />
                </div>
                <div className="mb-3">
                  <label className="chi-label">Phone Number *</label>
                  <input type="tel" className="chi-input" name="from_phone" placeholder="(555) 000-0000" required />
                </div>
                <div className="mb-4">
                  <label className="chi-label">Message *</label>
                  <textarea className="chi-input" name="message" rows="4"
                    placeholder="Tell us about your shipment or inquiry..." required />
                </div>
                <button type="submit" className="chi-btn">Send Message</button>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-6" data-aos="fade-left">
            <div className="contact__card">
              <h5 className="contact__card-title">Get in Touch</h5>
              <p className="contact__card-sub">We're available by phone, email, or in person at our Fresno office.</p>

              <div className="contact-info-item">
                <div className="contact-info-item__icon"><FaMapMarkerAlt className="footer-icon" /></div>
                <div>
                  <p className="contact-info-item__label">Address</p>
                  <a href="https://www.google.com/maps/place/4616+S+Cedar+Ave,+Fresno,+CA+93725"
                    target="_blank" rel="noopener noreferrer" className="contact-info-item__value">
                    4616 S Cedar Ave, Fresno, CA 93725
                  </a>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-item__icon"><FaPhone className="footer-icon" /></div>
                <div>
                  <p className="contact-info-item__label">Phone / Text</p>
                  <a href="tel:+15594971301" className="contact-info-item__value">(559) 497-1301</a>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-item__icon"><FaEnvelope className="footer-icon" /></div>
                <div>
                  <p className="contact-info-item__label">Email</p>
                  <a href="mailto:safety@chilogistic.com" className="contact-info-item__value">
                    safety@chilogistic.com
                  </a>
                </div>
              </div>

              <div className="contact-apply-banner">
                <p>
                  Interested in driving for C.H.I.?{' '}
                  <Link to="/apply">Submit your driver application here &rarr;</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
